import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { HistoryState, initialHistoryState } from './types'

export const history: Module<HistoryState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialHistoryState),
  actions,
  getters,
  mutations,
}
